var map = {
	"./0.svg": "50e0",
	"./1.svg": "74f8",
	"./10.svg": "e8fa",
	"./2.svg": "6451",
	"./3.svg": "1229",
	"./4.svg": "3121",
	"./5.svg": "46c5",
	"./6.svg": "5df8",
	"./7.svg": "8904",
	"./8.svg": "a300",
	"./9.svg": "79ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8f5";